import React from 'react'
import { Box, Container, Heading, useToast } from '@chakra-ui/react'
import { UseCadastroDeProdutoAPI } from './hooks/useCadastroDeProdutoAPI'
import ListaProdutos from './components/ListaProdutos'
import FiltrosProdutos from './components/FiltrosProdutos'
import ModalStatus from './components/ModalStatus'
import ModalAdicionarProdutos from './components/ModalAdicionarProdutos'
import ModalEditarProduto from './components/ModalEditarProduto'
import ModalEditarProdutoStepper from './components/ModalEditarProdutoStepper'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './components/ErrorFallback'

export function CadastroDeProdutoAPI() {
  const toast = useToast()
  const {
    produtos,
    filtros,
    isLoading,
    paginacao,
    modalStatus,
    modalAdicionar,
    modalEditar,
    statusData,
    produtoEmEdicao,
    tiposImpressao,
    isModoStepByStep,

    handleChangeFiltro,
    handleChangePaginacao,
    handleChangeLimite,
    handleBuscarProdutos,
    handleAbrirModalStatus,
    handleFecharModalStatus,
    handleAbrirModalAdicionar,
    handleFecharModalAdicionar,
    handleAbrirModalEditar,
    handleFecharModalEditar,
    handleAdicionarProdutos,
    handleAdicionarFoto,
    handleAlterarPrioridade,
    handleSalvarEdicaoProduto,
    handleDeletarProduto,
    handleEditarObservacao,
  } = UseCadastroDeProdutoAPI(toast)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Container maxW="1366px" px={2} py={5}>
        <Box mb={6} display="flex" justifyContent="space-between" alignItems="center">
          <Heading size="lg">Cadastro de Produtos API</Heading>
        </Box>

        <FiltrosProdutos
          filtros={filtros}
          isLoading={isLoading}
          onChangeFiltro={handleChangeFiltro}
          onBuscar={handleBuscarProdutos}
          onAbrirModalStatus={handleAbrirModalStatus}
          onAbrirModalAdicionar={handleAbrirModalAdicionar}
        />

        <ListaProdutos
          produtos={produtos}
          isLoading={isLoading}
          paginacao={paginacao}
          onChangePaginacao={handleChangePaginacao}
          onChangeLimite={handleChangeLimite}
          onAlterarPrioridade={handleAlterarPrioridade}
          onAbrirModalEditar={handleAbrirModalEditar}
          onAdicionarFoto={handleAdicionarFoto}
          onDeletarProduto={handleDeletarProduto}
          onEditarObservacao={handleEditarObservacao}
        />

        <ModalStatus isOpen={modalStatus.isOpen} onClose={handleFecharModalStatus} statusData={statusData} isLoading={isLoading} />

        <ModalAdicionarProdutos
          isOpen={modalAdicionar.isOpen}
          onClose={handleFecharModalAdicionar}
          isLoading={isLoading}
          onAdicionarProdutos={handleAdicionarProdutos}
        />

        {isModoStepByStep ? (
          <ModalEditarProdutoStepper
            isOpen={modalEditar.isOpen}
            onClose={handleFecharModalEditar}
            produto={produtoEmEdicao}
            isLoading={isLoading}
            onSalvar={handleSalvarEdicaoProduto}
          />
        ) : (
          <ModalEditarProduto
            isOpen={modalEditar.isOpen}
            onClose={handleFecharModalEditar}
            produto={produtoEmEdicao}
            isLoading={isLoading}
            onSalvar={handleSalvarEdicaoProduto}
            tiposImpressao={tiposImpressao}
          />
        )}
      </Container>
    </ErrorBoundary>
  )
}
